export default __webpack_public_path__ + "static/media/az.ade0cc94.svg";